import { AssetType } from '../../api/models/Shared.types';
import { IReminderElementV1, IScheduleDetailV5 } from '../../api/models/AndromeTV.types';
import { ReminderWorkerMessageTypes } from './Reminders.worker';

export interface ReminderWorkerMessage {
  type: ReminderWorkerMessageTypes;
  items: ReminderWorkerMessageItem[];
  message: string; // debug ping message
}

export interface ReminderWorkerMessageItem {
  model: ReminderModel;
  time: number;
}

export class ReminderModel {
  type!: AssetType;
  id!: string;
  minutes?: number;

  // schedule
  public schedule: IScheduleDetailV5;

  constructor(obj: IReminderElementV1, schedule: IScheduleDetailV5) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    Object.keys(obj).forEach(key => (this[key] = obj[key]));
    this.schedule = schedule;
  }
}
